import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import AppButton from "@/features/line-sheet-sets/app-button";
import CustomApprovalModal from "@/shared/components/custom-modal";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import { SMARTSTORE_DELIVERY_TEMPLATE_GUIDE_URL } from "@/features/pathpick/features/basket/constants";

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

// 스마트스토어에서 배송비 템플릿 코드를 어디서 확인하는지 알려주는 안내 모달
function PathPickBasketDeliveryTemplateGuideModal({ isOpen, onClose }: Props) {
  const { t } = useI18nHelper();

  const handleOpenOfficialGuide = () => {
    window.open(
      SMARTSTORE_DELIVERY_TEMPLATE_GUIDE_URL,
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <CustomApprovalModal
      isOpen={isOpen}
      onClose={onClose}
      // 화면보다 넓으면 왼쪽이 스크롤로도 닿지 않아 화면 폭으로 클램프한다.
      minWidth={"min(560px, 92dvw)"}
      isCentered={true}
    >
      <CustomApprovalModal.Header
        onClose={onClose}
        title={t("path_pick:basket.buyer_info.template_code_guide.title")}
      />
      <CustomApprovalModal.Body>
        <Flex flexDirection={"column"} gap={"12px"}>
          <Text textStyle={"body-md-bold"} color={"#1D1D1B"}>
            {t("path_pick:basket.buyer_info.template_code_guide.heading")}
          </Text>
          <Text textStyle={"body-sm-medium"} color={"#8F8F8C"}>
            {t("path_pick:basket.buyer_info.template_code_guide.body")}
          </Text>
          <Text
            textStyle={"body-sm-bold"}
            color={"#1272EF"}
            width={"fit-content"}
            cursor={"pointer"}
            textDecoration={"underline"}
            onClick={handleOpenOfficialGuide}
          >
            {t("path_pick:basket.buyer_info.template_code_guide.official_link")}
          </Text>
          {/* 확인 버튼만 필요해서 공용 Footer(취소 버튼 고정 노출) 대신 직접 렌더한다. */}
          <Flex justifyContent={"flex-end"}>
            <AppButton variant={"primary"} width={"80px"} onClick={onClose}>
              <Text textStyle={"body-sm-bold"}>
                {t("path_pick:basket.buyer_info.template_code_guide.confirm")}
              </Text>
            </AppButton>
          </Flex>
        </Flex>
      </CustomApprovalModal.Body>
    </CustomApprovalModal>
  );
}

export default PathPickBasketDeliveryTemplateGuideModal;
